import styled from 'styled-components';

export const DescriptionWrapper = styled.div`
  margin-bottom: 32px;
`;

export const DescriptionTitle = styled.p`
  ${(props) => props.theme.typography.subHeader2}
`;

export const DescriptionText = styled.p`
  color: ${(props) => props.theme.colors.muted};
`;

export const ToggleWrapper = styled.div`
  padding-top: 24px;
`;
